
import { Options, prop, Vue } from "vue-class-component";
import PaginationV3 from "@/app/ui/components/pagination-v3/index.vue";
import { Pagination } from "@/domain/entities/Pagination";
import Skeleton from "@/app/ui/components/skeleton/index.vue";

class Props {
  column = prop<any[]>({
    default: () => [],
    type: Array
  });
  tableData = prop<any[]>({
    default: () => [],
    type: Array
  });
  sortBy = prop<string>({
    default: ""
  });
  sortDirection = prop<string>({
    default: ""
  });
  substractHeight = prop<string>({
    default: "377"
  });
  pagination = prop<Pagination>({
    default: () => new Pagination(1, 10, 100)
  });
  loading = prop<boolean>({
    default: false
  });
}

@Options({
  components: {
    PaginationV3,
    Skeleton
  },
  emits: ["update:page"]
})
class CourierTable extends Vue.with(Props) {
  onSort(sortBy = "") {
    if (!this.sortDirection || this.sortBy !== sortBy) {
      return this.$emit("sort", { sortBy, sortDirection: "ASC"})
    }
    if (this.sortDirection === "ASC") return this.$emit("sort", { sortBy, sortDirection: "DESC"})
    if (this.sortDirection === "DESC") return this.$emit("sort", { sortBy: "", sortDirection: ""})
  }

  setPage(page = 1) {
    this.$emit("update:page", page);
    this.$emit("request");
  }
}

export default CourierTable;
